import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import LineItems from 'modules/finance/components/Invoices/SaleInvoiceDetail/_LineItems'
import Summary from 'modules/finance/components/Quotes/QuotesDetail/_Summary'
import { QuoteDocument } from 'modules/finance/components/Quotes/utils'

interface MainContentProps {
  quote: QuoteDocument
  locale: string
  showQuoteNumber?: boolean
}

const MainContent = ({ quote, locale, showQuoteNumber = false }: MainContentProps) => {
  const saleInvoiceDocument = {
    ...quote,
    documentNumber: quote.quoteNumber,
    dueDate: quote.expirationDate,
    vendor: quote.client,
  }

  return (
    <Box gap="s24" flexDirection="column">
      <Box paddingLeft="s6">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('finance.sale_invoices.detail.summary')}
        </Text.Normal>
      </Box>
      <Box gap="s16" width="full">
        <Summary quote={quote} showQuoteNumber={showQuoteNumber} />
        <LineItems locale={locale} saleInvoice={saleInvoiceDocument} />
      </Box>
    </Box>
  )
}

export default MainContent
